<template>
  <div class="tip_box">
    <div v-if="otaGatewaySupport">
      <div class="tip_box_title">
        <i class="el-icon-info" style="margin: 0 8px" />
        <span style="font-size: 14px;">{{ title }}</span>
      </div>
      <!-- <div class="tip_box_empty" /> -->
      <div class="tip_box_table">
        <el-table
          border
          :data="otaGatewaySupportList"
          header-row-class-name="tip_box_table_th"
          :row-style="{ backgroundColor: '#F5F8FD' }"
        >
          <el-table-column
            prop="DeviceName"
            :header-row-style="{ backgroundColor: '#fff' }"
            :label="$t('deviceMsg.devicename')"
          />
          <el-table-column v-if="sceneOta" prop="AreaName" :label="`${$t(iftttset.areaName)}`" />
        </el-table>
      </div>
      <div class="tip_box_footer" />
    </div>
    <div v-if="contentJudge == 1 && otaUpdateIsShow">
      <div class="tip_box_title">
        <span style="font-size: 14px;">{{ title || $t('install.otaTipTitle3') }}</span>
        <span style="font-size: 14px">
          <slot name="content" />
        </span>
      </div>
      <!-- <div class="tip_box_empty" /> -->
      <div class="tip_box_table">
        <el-table
          border
          :data="newDeviceSelected"
          header-row-class-name="tip_box_table_th"
          :row-style="{ backgroundColor: '#F5F8FD' }"
        >
          <el-table-column
            prop="DeviceName"
            :header-row-style="{ backgroundColor: '#fff' }"
            width="130"
            :label="$t('deviceMsg.devicename')"
          />
          <el-table-column prop="DeviceTypeName" width="130" :label="$t('install.deviceType')" />
          <el-table-column width="130" prop="Mac" label="Mac" />
          <el-table-column prop="ClassSku" label="classsku" />
          <el-table-column width="130" prop="LocalVersion" :label="$t('deviceMsg.currentversion')" />
          <el-table-column width="130" prop="LatestVersion" :label="$t('deviceMsg.newversion')" />
        </el-table>
      </div>
      <div class="tip_box_footer">
        <div>
          <el-checkbox v-model="neverTipchecked" @change="handleCheckboxChange">
            {{ $t('install.doNotShowThisAgain') }}
          </el-checkbox>
        </div>
        <button @click="doRemoveArea">
          {{ $t('install.continue') }}
        </button>
        <button @click="doWebUpdate">
          {{ $t('install.toWebTip') }}
        </button>
        <button v-if="appUpdateIsShow" @click="doAppUpdate">
          {{ $t('install.toAppbTip') }}
        </button>
      </div>
    </div>
    <div v-else-if="contentJudge == 2 && otaUpdateIsShow">
      <div class="tip_box_title">
        <i class="el-icon-info" />
        <span style="font-size: 14px;">{{ title || $t('install.otaTipTitle1') }}</span>
        <span style="font-size: 14px">
          <slot name="content" />
        </span>
      </div>
      <div class="tip_box_table">
        <el-table
          border
          :data="newDeviceSelected"
          header-row-class-name="tip_box_table_th"
          :row-style="{ backgroundColor: '#F5F8FD' }"
        >
          <el-table-column
            prop="DeviceName"
            :header-row-style="{ backgroundColor: '#fff' }"
            width="130"
            :label="$t('deviceMsg.devicename')"
          />
          <el-table-column prop="DeviceTypeName" width="130" :label="$t('install.deviceType')" />
          <el-table-column width="130" prop="Mac" label="Mac" />
          <el-table-column prop="ClassSku" label="classsku" />
          <el-table-column width="130" prop="LocalVersion" :label="$t('deviceMsg.currentversion')" />
          <el-table-column width="130" prop="LatestVersion" :label="$t('deviceMsg.newversion')" />
        </el-table>
      </div>
      <div class="tip_box_footer">
        <button v-if="webUpdateIsShow" @click="doWebUpdate">
          {{ $t('install.toWebTip') }}
        </button>
        <button v-if="appUpdateIsShow" @click="doAppUpdate">
          {{ $t('install.toAppbTip') }}
        </button>
      </div>
    </div>
    <div v-else-if="contentJudge == 3 && otaUpdateIsShow">
      <div class="tip_box_title">
        <i class="el-icon-info" style="margin: 0 8px" />
        {{ $t('install.otaTipTitle2') }}
      </div>
      <div class="qrcode_box">
        <div class="qrcode_box_content">
          <img src="../../../assets/img/qrcode/app_download_opple_smart_system.png">
        </div>
      </div>
      <div class="tip_box_footer">
        <button @click="closeDialog">
          {{ $t('install.getInfo') }}
        </button>
      </div>
    </div>
    <!-- 添加房间强制升级优化 -->
    <div v-else-if="contentJudge == 4 && otaUpdateIsShow">
      <div class="tip_box_title">
        <i class="el-icon-info" style="margin: 0 8px" />
        <span style="font-size: 14px">{{ (computedTitle3()) }}</span>
      </div>
      <div class="tip_box_table">
        <el-table
          border
          :data="newDeviceSelected"
          header-row-class-name="tip_box_table_th"
          :row-style="{ backgroundColor: '#F5F8FD' }"
        >
          <el-table-column
            prop="DeviceName"
            :header-row-style="{ backgroundColor: '#fff' }"
            width="130"
            :label="$t('deviceMsg.devicename')"
          />
          <el-table-column prop="DeviceTypeName" width="130" :label="$t('install.deviceType')" />
          <el-table-column width="130" prop="Mac" label="Mac" />
          <el-table-column prop="ClassSku" label="classsku" />
          <el-table-column width="130" prop="LocalVersion" :label="$t('deviceMsg.currentversion')" />
          <el-table-column width="130" prop="LatestVersion" :label="$t('deviceMsg.newversion')" />
        </el-table>
      </div>
      <div class="tip_box_footer">
        <button v-if="webUpdateIsShow" @click="goToINstall">
          {{ $t('install.continue') }}
        </button>
        <button v-if="appUpdateIsShow" @click="goToNoArea">
          {{ $t('install.finsh') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { parseVersionName } from '@/utils/parseVersionName.js'
import { CreateMulticastTask } from '@/axios/IOtaTask.js';
import { INSTALL_KEY, TREE_ID_KEY, GPNO_KEY, TREE_LEVEL_KEY, PATH_NAME , PARENT_NODES, Path} from '@/enums/localStorageKey';

export default {
  name: 'OtaUpdateDialog',
  props: {
    newDeviceSelected: {
      type: Array,
      default() {
        return []
      },
    },
    moveType: {
      type: Number,
      default: 2,
    },
    title: {
      type: String,
      default: '',
    },
    appUpdateIsShow: {
      type: Boolean,
      default: true,
    },
    webUpdateIsShow: { 
      type: Boolean,
      default: true,
    },
    otaGatewaySupport: {
      type: Boolean,
      default: false,
    },
    otaGatewaySupportList: {
      type: Array,
      default() {
        return []
      },
    },
    otaUpdateIsShow: {
      type: Boolean,
      default: true,
    },
    navigateToOtaTaskType: {
      type: String,
      default: 'NewTab',
    },
    sceneOta: {
      type: Boolean,
      default: false,
    },
    isMoveForceOta: {
      type: Boolean,
      default: false,
    },
    moveTypeTip:{
      type: Object,
      default:()=>({})
    }
  },
  data() {
    return {
      contentJudge: this.moveType, //设备详情移动 1，无区域移动 2，app升级 3
      removeFlag: false,
      neverTipchecked: false,
      defaultTitle1: this.$t('install.otaTipTitle3'),
      defaultTitle2: this.$t('install.otaTipTitle1'),
    }
  },
  computed: {
    computedTitle1() {
      return this.title || this.defaultTitle1
    },
    computedTitle2() {
      return this.title || this.defaultTitle2
    },
  },
  watch: {
    title(newVal) {
      console.log('newVal', newVal)
    },
  },
  mounted() {
  },
  methods: {
    goToINstall(){
      this.$router.push({name:'install'})
    },
    goToNoArea(){
      let _para = {
          keyword: "",
          protocoltype: [],
          childCategoryType: [],
          treemodel: {
              id: 0,
              name: this.$t('install.noarea'),
              treelevel: null
          }
      }
      this.$store.dispatch('changeSearchParas', JSON.stringify(_para))
      this.SetStoreCacheObj(INSTALL_KEY, GPNO_KEY, 0)
      this.$router.push({name:'install'})
    },
    computedTitle3(){
      const {needOTaNUm, totalNUm, successMoveNUm} = this.moveTypeTip
      const tip = this.$t('install.addResult').replace('#', totalNUm).replace('#', successMoveNUm).replace('#', needOTaNUm)
      return tip
    },
    handleCheckboxChange() {
      // 获取当前的 tips 数组或初始化为一个空数组
      let tips = JSON.parse(getLocalStoragItem('tips')) || []
      if (this.neverTipchecked) {
        for (let i = 0; i < this.newDeviceSelected.length; i++) {
          const vDeviceId = this.newDeviceSelected[i].vDeviceId
          // 如果 tips 中不包含该 vDeviceId，则添加
          if (!tips.includes(vDeviceId)) {
            tips.push(vDeviceId)
          }

          // 将 vDeviceId 存储到 localStorage 中
          setLocalStoragItem('tips', JSON.stringify(tips))
        }
      } else {
        for (let i = 0; i < this.newDeviceSelected.length; i++) {
          const vDeviceId = this.newDeviceSelected[i].vDeviceId
          // 如果 tips 中包含该 vDeviceId，则删除
          tips = tips.filter(id => id !== vDeviceId)
          // 从 localStorage 中移除 vDeviceId
          setLocalStoragItem('tips', JSON.stringify(tips))
        }
      }
      //
    },
    parseVersionName: parseVersionName,
    closeDialog() {
      this.$emit('closeDialog')
    },
    doRemoveArea() {
      this.removeFlag = true
      this.$emit('doRemoveArea', this.removeFlag)
    },
    async doWebUpdate() {
      debugger
      // 移动导致的强制升级
      if (this.isMoveForceOta) {
        const updateDeviceList = this.newDeviceSelected;

        const UpgradeSourceTypeList = {}
        
        updateDeviceList.forEach(item => {
          const newFirmList = (item.firmList || []).map(item => item.SourceType);

          if (UpgradeSourceTypeList.ClassSku) {
            UpgradeSourceTypeList[item.ClassSku] = [ ...new Set(UpgradeSourceTypeList[item.ClassSku].concat(newFirmList))];
          } else {
            UpgradeSourceTypeList[item.ClassSku] = newFirmList;
          }        
        })

        const params = {
          GpNo: 0,
          Start: false,
          TaskName: this.$t('install.forceUpgrade'),
          UpgradeSourceTypeList,
          keep: false,
          ForceUpgradingLowCapacityDevice:false,
          ForceUpgradingOfflineDevice:false
        };

        const res = await CreateMulticastTask(params);

        if (res.StatusCode == this.$store.state.rightStatusCode) {
            const url = this.$router.resolve({ name: 'otatask'}).href;
            window.location.href = url;
            this.$store.dispatch('changeRoutermsg', '/otatask')
        }

        this.$emit('isMoveForceOta')
      } else {
        const url = this.$router.resolve({ name: 'otatask', query: { from: 'install' } }).href;
  
         // 使用 window.location.href 打开新的标签页
         if (this.navigateToOtaTaskType === 'NewTab') {
            window.open(url, '_blank');
         } else {
           window.location.href = url;
         }
        
          this.$store.dispatch('changeRoutermsg', '/otatask')
      }
    },
    doAppUpdate() {
      this.contentJudge = 3
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if ((columnIndex == 4 || columnIndex == 5) && row.currentVersionList.length > 1) {
        return [row.currentVersionList.length, 1]
      } else {
        return [1, 1]
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tip_box {
  max-height: 500px;
  overflow: auto;
  padding: 0 20px;
  &_title {
    i {
      width: 21px;
      height: 21px;
      margin-right: 10px;
      transform: translateY(3px);
    }
    color: #595959;
    font-size: 18px;
  }
  &_empty {
    width: 100%;
    // height: 50px;
  }
  &_table {
    width: 100%;
    margin-top: 18px;
    //height: 300px;
    overflow: auto;
  }

  .qrcode_box {
    padding-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 124px;
      height: 126px;
    }
  }
  &_footer {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    button {
      min-width: 120px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      margin-left: 12px;
      padding: 0 20px;
      border: 1px solid #2145a4;
      border-radius: 4px;
      background-color: #2145a4;
    }
  }
  ::v-deep.tip_box_table_th th {
    background-color: #fff !important;
  }
  >>> .el-table__cell {
    font-size: 12px;
  }
}
.bottom_border_box {
  border-bottom: 1px solid #c7c6c6;
  width: 136%;
  text-align: center;
  margin-left: -10px;
}
.bottom_border_box:last-child {
  border-bottom: none;
}


</style>
